module.exports = __webpack_public_path__ + "workspace/static/img/table.697d73a.svg";